import { Redirect } from "react-router-dom";
import { LoadingOrb } from "../../components/LoadingOrb";
import { SomethingWentWrong } from "../../components/SomethingWentWrong";
import { useAddIngredientInitialQuery, useAddIngredientMutation } from "../../store/data/ingredientsSlice";
import { IngredientForm } from "../../components/forms/IngredientForm";
import { DataLoadingWardenForQuery } from "../../components/DataLoadingWardenForQuery";

class ContainerProps {}

export const IngredientAddForm: React.FC<ContainerProps> = () => {
    const initial = useAddIngredientInitialQuery({});
    const [add, result] = useAddIngredientMutation();

    if (result.isLoading) {
        return <LoadingOrb text="Zapisuję..." />;
    }
    if (result.error && result.error?.status !== 400) {
        return <SomethingWentWrong text="Coś poszło nie tak :(" />;
    }
    if (result.isSuccess) {
        return <Redirect to="/dictionaries/ingredients" />;
    }
    return (
        <div className="ingredient-add-form-component form-content">
            <DataLoadingWardenForQuery query={initial}>
                {() => (
                    <IngredientForm
                        data={result.originalArgs?.body || initial.data}
                        submitForm={(data) => add({ body: data })}
                        errors={result.error?.data || {}}
                    />
                )}
            </DataLoadingWardenForQuery>
        </div>
    );
};
